import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAssignedSubTaskById } from "../../../Redux/Slice/TaskMasterSlice";
import { useParams } from "react-router-dom";
import Cookies from "js-cookie";

const AssignTaskDetail = () => {
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    return `${date.getDate().toString().padStart(2, "0")}/${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}/${date.getFullYear()}`;
  };

  const loginData = Cookies.get("loginData");
  const parsedData = loginData ? JSON.parse(loginData) : null;

  const dispatch = useDispatch();
  const { id } = useParams();

  const { AssignedSubTaskData } = useSelector((state) => state.TaskMaster);

  useEffect(() => {
    dispatch(fetchAssignedSubTaskById(id));
  }, [dispatch, id]);

  return (
    <>
      <div className="p-1 sm:p-2 bg-gray-100 min-h-screen">
        {parsedData?.data?.Role === "owner" ? (
          <>
            <div className="p-0 md:p-4">
              <h3 className="text-2xl font-bold main_title_page text-white px-4 py-2 mb-6 inline-block rounded">
                Main Task Details
              </h3>
              <div className="bg-white shadow-lg rounded-2xl p-6 border border-gray-200">
                <div className="bg-white shadow rounded-xl p-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Remark */}
                    <div>
                      <p className="text-base font-semibold text-black uppercase mb-1">
                        Remark
                      </p>
                      <p className="text-gray-800">
                        {AssignedSubTaskData?.data?.Remark || "-"}
                      </p>
                    </div>

                    {/* Assign Date */}
                    <div>
                      <p className="text-base font-semibold text-black uppercase mb-1">
                        Assign Date
                      </p>
                      <p className="text-gray-800">
                        {formatDate(AssignedSubTaskData?.data?.AssignDate) ||
                          "-"}
                      </p>
                    </div>

                    {/* Assigned By */}
                    <div>
                      <p className="text-base font-semibold text-black uppercase mb-1">
                        Assigned By
                      </p>
                      <p className="text-gray-800">
                        {AssignedSubTaskData?.data?.AssignedBy?.Name || "-"}
                      </p>
                    </div>

                    {/* Company Name */}
                    <div>
                      <p className="text-base font-semibold text-black uppercase mb-1">
                        Company Name
                      </p>
                      <p className="text-gray-800">
                        {AssignedSubTaskData?.data?.CompanyId?.CompanyName ||
                          "-"}
                      </p>
                    </div>

                    {/* Due Date */}
                    <div>
                      <p className="text-base font-semibold text-black uppercase mb-1">
                        Due Date
                      </p>
                      <p className="text-gray-800">
                        {formatDate(AssignedSubTaskData?.data?.DueDate) || "-"}
                      </p>
                    </div>

                    {/* Description */}
                    <div className="md:col-span-2">
                      <p className="text-base font-semibold text-black uppercase mb-1">
                        Description
                      </p>
                      <p className="text-gray-800">
                        {AssignedSubTaskData?.data1?.Description || "-"}
                      </p>
                    </div>

                    {/* Project */}
                    <div>
                      <p className="text-base font-semibold text-black uppercase mb-1">
                        Project
                      </p>
                      <p className="text-gray-800">
                        {AssignedSubTaskData?.data1?.Project?.project_name ||
                          "-"}
                      </p>
                    </div>

                    {/* Task Name */}
                    <div>
                      <p className="text-base font-semibold text-black uppercase mb-1">
                        Task Name
                      </p>
                      <p className="text-gray-800">
                        {AssignedSubTaskData?.data1?.TastName || "-"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            {parsedData?.data?.Role === "inhouse" ? (
              <div className="p-0 md:p-4">
                <h3 className="text-2xl font-bold main_title_page text-white px-4 py-2 mb-6 inline-block rounded">
                  Main Task Details
                </h3>
                <div className="bg-white shadow-lg rounded-2xl p-6 border border-gray-200">
                  <div className="bg-white shadow rounded-xl p-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {/* Remark */}
                      <div>
                        <p className="text-base font-semibold text-black uppercase mb-1">
                          Remark
                        </p>
                        <p className="text-gray-800">
                          {AssignedSubTaskData?.data?.Remark || "-"}
                        </p>
                      </div>

                      {/* Assign Date */}
                      <div>
                        <p className="text-base font-semibold text-black uppercase mb-1">
                          Assign Date
                        </p>
                        <p className="text-gray-800">
                          {formatDate(AssignedSubTaskData?.data?.AssignDate) ||
                            "-"}
                        </p>
                      </div>

                      {/* Assigned By */}
                      <div>
                        <p className="text-base font-semibold text-black uppercase mb-1">
                          Assigned By
                        </p>
                        <p className="text-gray-800">
                          {AssignedSubTaskData?.data?.AssignedBy?.Name || "-"}
                        </p>
                      </div>

                      {/* Company Name */}
                      <div>
                        <p className="text-base font-semibold text-black uppercase mb-1">
                          Company Name
                        </p>
                        <p className="text-gray-800">
                          {AssignedSubTaskData?.data?.CompanyId?.CompanyName ||
                            "-"}
                        </p>
                      </div>

                      {/* Due Date */}
                      <div>
                        <p className="text-base font-semibold text-black uppercase mb-1">
                          Due Date
                        </p>
                        <p className="text-gray-800">
                          {formatDate(AssignedSubTaskData?.data?.DueDate) ||
                            "-"}
                        </p>
                      </div>

                      {/* Description */}
                      <div className="md:col-span-2">
                        <p className="text-base font-semibold text-black uppercase mb-1">
                          Description
                        </p>
                        <p className="text-gray-800">
                          {AssignedSubTaskData?.data1?.Description || "-"}
                        </p>
                      </div>

                      {/* Project */}
                      <div>
                        <p className="text-base font-semibold text-black uppercase mb-1">
                          Project
                        </p>
                        <p className="text-gray-800">
                          {AssignedSubTaskData?.data1?.Project?.project_name ||
                            "-"}
                        </p>
                      </div>

                      {/* Task Name */}
                      <div>
                        <p className="text-base font-semibold text-black uppercase mb-1">
                          Task Name
                        </p>
                        <p className="text-gray-800">
                          {AssignedSubTaskData?.data1?.TastName || "-"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="p-0 md:p-4">
                <h3 className="text-2xl font-bold main_title_page text-white px-4 py-2 mb-6 inline-block rounded">
                  Main Task Details
                </h3>
                <div className="bg-white shadow-lg rounded-2xl p-6 border border-gray-200">
                  <div className="bg-white shadow rounded-xl p-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {/* Remark */}
                      <div>
                        <p className="text-base font-semibold text-black uppercase mb-1">
                          Remark
                        </p>
                        <p className="text-gray-800">
                          {AssignedSubTaskData?.data?.Remark || "-"}
                        </p>
                      </div>

                      {/* Assign Date */}
                      <div>
                        <p className="text-base font-semibold text-black uppercase mb-1">
                          Assign Date
                        </p>
                        <p className="text-gray-800">
                          {formatDate(AssignedSubTaskData?.data?.AssignDate) ||
                            "-"}
                        </p>
                      </div>

                      {/* Assigned By */}
                      <div>
                        <p className="text-base font-semibold text-black uppercase mb-1">
                          Assigned By
                        </p>
                        <p className="text-gray-800">
                          {AssignedSubTaskData?.data?.AssignedBy?.Name || "-"}
                        </p>
                      </div>

                      {/* Company Name */}
                      <div>
                        <p className="text-base font-semibold text-black uppercase mb-1">
                          Company Name
                        </p>
                        <p className="text-gray-800">
                          {AssignedSubTaskData?.data?.CompanyId?.CompanyName ||
                            "-"}
                        </p>
                      </div>

                      {/* Due Date */}
                      <div>
                        <p className="text-base font-semibold text-black uppercase mb-1">
                          Due Date
                        </p>
                        <p className="text-gray-800">
                          {formatDate(AssignedSubTaskData?.data?.DueDate) ||
                            "-"}
                        </p>
                      </div>

                      {/* Description */}
                      <div className="md:col-span-2">
                        <p className="text-base font-semibold text-black uppercase mb-1">
                          Description
                        </p>
                        <p className="text-gray-800">
                          {AssignedSubTaskData?.data1?.Description || "-"}
                        </p>
                      </div>

                      {/* Project */}
                      <div>
                        <p className="text-base font-semibold text-black uppercase mb-1">
                          Project
                        </p>
                        <p className="text-gray-800">
                          {AssignedSubTaskData?.data1?.Project?.project_name ||
                            "-"}
                        </p>
                      </div>

                      {/* Task Name */}
                      <div>
                        <p className="text-base font-semibold text-black uppercase mb-1">
                          Task Name
                        </p>
                        <p className="text-gray-800">
                          {AssignedSubTaskData?.data1?.TastName || "-"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default AssignTaskDetail;
